import type { User } from '@/configs/apis/user';
import type { Contact } from '@/contexts/contacts/types';
import styles from './index.module.scss';

const OperationBar = ({
  contacts,
  user,
  onAdd,
}: {
  contacts: Contact[];
  user: User;
  onAdd: (user: User) => ResolveValue<void>;
}) => {
  const [loading, setLoading] = useState(false);
  const isAdded = contacts.find((contact) => contact.user_id === user.userId);
  if (isAdded) {
    return <div className={styles.added}>Added</div>;
  }
  return (
    <Button
      className={styles.add}
      size="small"
      // variant="outlined"
      // color="primary"
      type="primary"
      loading={loading}
      onClick={async (e) => {
        e.stopPropagation();
        setLoading(true);
        try {
          await onAdd(user);
        } finally {
          setLoading(false);
        }
      }}
    >
      Add
    </Button>
  );
};

export default OperationBar;
